import { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import type FlightInfoStore from '@tajawal/web-flights-sdk/lib/stores/flight-info.store';
import { APIError } from '@tajawal/web-core-sdk-v2/lib/utils/sentry.utils';
import { RecentSearchCache } from '@/app-common/components/SearchBox/utils/cache.utils';
import _uniq from 'lodash/uniq';

export default function useFetchResources({
  store,
  codes,
  shouldFetch = true,
}: {
  store: FlightInfoStore;
  codes: any[];
  shouldFetch?: boolean;
}): void {
  const recentOrigins = RecentSearchCache.getOrigin() || [];
  const recentDestinations = RecentSearchCache.getDestination() || [];

  const resourcesToFetch = _uniq([...recentOrigins, ...recentDestinations, ...codes]);

  useEffect(() => {
    function handleError(error) {
      // @ts-ignore
      APIError({ error, payload: { codes: resourcesToFetch }, tag: 'RESOURCES_FETCH_ERROR' });
    }
    /**
     * resources fetch
     */
    if (!_isEmpty(codes) && shouldFetch) {
      store.resources.fetch({ codes: resourcesToFetch, errorHandler: handleError });
    }
  }, [codes, store]);
}
